import React, { useState, useEffect, useRef } from "react";
import { Box, useMediaQuery } from "@mui/material";
import video from "../Media/vid.mp4";

export default function FirstSlide() {
  const matches = useMediaQuery("(min-width:635px)");
  const [videoReady, setVideoReady] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => {
    const videoElement = videoRef.current;
    const storedTime = localStorage.getItem("videoPlaybackTime");

    const handleVideoLoaded = () => {
      setVideoReady(true);
      if (storedTime) {
        videoElement.currentTime = parseFloat(storedTime);
      }
      videoElement.play().catch((error) => {
        // Handle autoplay error
        console.error("Failed to play the video:", error);
      });
    };

    videoElement.addEventListener("loadeddata", handleVideoLoaded);

    const handleVideoTimeUpdate = () => {
      localStorage.setItem(
        "videoPlaybackTime",
        videoElement.currentTime.toString()
      );
    };

    videoElement.addEventListener("timeupdate", handleVideoTimeUpdate);

    return () => {
      videoElement.removeEventListener("loadeddata", handleVideoLoaded);
      videoElement.removeEventListener("timeupdate", handleVideoTimeUpdate);
    };
  }, []);

  return (
    <Box
      sx={{
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
        flexWrap: "wrap",
      }}
    >
      <Box
        sx={{
          position: "relative",
          borderRadius: "20px",
          overflow: "hidden",
          width: matches ? "75%" : "100%",
          height: "500px",
        }}
      >
        <video
          ref={videoRef}
          src={video}
          autoPlay
          loop
          muted
          style={{
            width: "100%",
            height: "100%",
            objectFit: "fill",
          }}
        />
        {!videoReady && (
          <Box
            sx={{
              position: "absolute",
              top: matches ? "50%" : "45%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              fontSize: "20px",
              fontWeight: "bold",
              color: "white",
            }}
          >
            Loading video...
          </Box>
        )}
      </Box>
    </Box>
  );
}
